import { SERVICE_API_KEY } from './constants';

export const setServiceApiKey = (apiKey) => {
  if (apiKey) {
    localStorage.setItem(SERVICE_API_KEY, apiKey);
  }
};

export const getServiceApiKey = () => {
  return localStorage.getItem(SERVICE_API_KEY) || '';
};

export const removeServiceApiKey = () => {
  localStorage.removeItem(SERVICE_API_KEY);
};

export const getApiKeyHeaders = () => ({
  'x-api-key': getServiceApiKey(),
});
